
/* eslint-disable */
// import axios from "axios";
import moment from "moment";
import axios from "axios";
import store from "../../store/index";
import TreeWithSidePopup from "../TreeWithSidePopup/TreeWithSidePopup.vue";
import TreeMove from "../TreeMove/TreeMove.vue";
import DocumentPopup from "../DocumentPopup/DocumentPopup.vue";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect"
import VuePdfEmbed from 'vue-pdf-embed'
import jwt_decode from "jwt-decode";
import { ref, computed, onMounted } from "vue";
import { isElementAccessExpression } from "typescript";
export default {
  name: "etmf",
  data() {
    return {
      countsMap: {},
      folderLookup: {},
      isArtifactOrInsideArtifact: false,
      documentUploadFields: {
        folderid: "",
        documentIdd: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
        ExpectedCompletionDate: ""
      },
      azuredata: {
        DocumentId: "",
        DocumentVersionId: "",
        DocumentTypeName: "",
        DocumentTitle: "",
        DocumentDescription: "",
        Document: [],
        OrganizationId: 2,
        Approver: [],
      },
      documentValidationsError: [false, false, false, false, false, false, false],
      addsigner: false,
      savefolder: false,
      roleprivileges: "",
      fileuploadurl: process.env.VUE_APP_File_upload_URL + "/document",
      baseurl: process.env.VUE_APP_Service_URL,
      baseapi: process.env.VUE_APP_Service_URL,
      folderlist: [],
      list: [],
      loaddata: false,
      versionNumber: "",
      values: {
        FolderName: "",
        AncestorIds: [],
        Approver: [],
        ParentId: "",
        storageId: "",
      },
      approveList: [],
      approverlist: "",
      retrieve: true,
      updateFolder: {
        id: "",
        folderName: "",
        ancestorIds: [],
        parentId: "",
        storageId: "",
      },
      folderbyid: {},
      errors: [],
      validations: [],
      showFolder: false,
      showDoc: false,
      showTableLoading: false,
      xlsFile: "",
      docTitle: "",
      docVersion: "",
      getfolderbyids: {},
      doclist: "",
      currentUser: "",
      docsId: "",
      documentName: "",
      documentById: "",
      docversioncount: "",
      parentFolderId: "",
      ShowDocName: true,
      totalPage: 1,
      currentPage: 1,
      totalCount: 0,
      pageindex: 1,
      pagesize: 10,
      storagevalue: "",
      SortProperty: "CreatedAt",
      SortOrder: 1,
      bold: "",
      office: ['xls', 'xlsx', 'doc', 'docx'],
      format: '',
      source: '',
      officeurl: '',
      isEditable: false,
      showFilter: false,
      dropdownOpen: false,
      showDocLoading: false,
      showFolderInfoLoading: false,
      changedFlag: false,
      showTreeLoading: true,
      editFolderModal: false,
      loadingGenerateBtn: false,
      uploadDocumentModal: false,
      loadingDocUpload: false,
      loadingEditFolder: false,
      loadingCloneFolder: false,
      openPermissionModal: false,
      openDocsPermissionModal: false,
      openFolderShareModal: false,
      loadingSaveModalBtn: false,
      anyuserpermissions: false,
      initialDocDownloader: false,
      openFileShareModal: false,
      initialLoader: false,
      openFileViewModal: false,
      documentLoader: false,
      showSelectTemplate: false,
      documentEdit: false,
      hasChild: false,
      initialTreeDownloader: false,
      initialPermissionLoader: false,
      showDocLoading: {},
      editFolderErrors: [false, false, false, false],
      loadingPermission: {},
      folderErrorMessages: ["Please enter a folder name"],
      selectedcolumnobj: {},
      selectedFolderswitch: {},
      userobject: {},
      getLatestVersionMsg: "",
      getDocumentData: {},
      SelectedFormat: [],
      ownerList: [],
      readMore: [false],
      readTitleMore: [false],
      selectedTemplate: "",
      openfolderlist: "",
      FormatList: [],
      documentList: [],
      categorylist: [],
      departmentlist: [],
      roleList: [],
      permissionList: [],
      designation: [],
      selectedRole: [],
      source: "",
      folderType: "",
      selectedDocument: "",
      doctypelist: [],
      standards: [],
      userList: [],
      templateList: [],
      lastAncestor: "",
      studyInfo: {},
      sendtoValue: "",
      permissionsValue: "",
      shareValue: "",
      editValue: "",
      deleteValue: "",
      archiveValue: "",
      downloadValue: "",
      viewValue: "",
      process: "",
      selectedFolderValue: "",
      cloneFolderModal: "",
      cloneType: "",
      location: "",
      newFolderName: "",
      prefix: "",
      majorVerStart: "",
      minorVerStart: "",
      minorVermax: "",
    };
  },
  components: {
    TreeWithSidePopup,
    VPagination,
    customModal,
    Multiselect,
    DocumentPopup,
    TreeMove,
    VuePdfEmbed
  },
  async mounted() {
    store.dispatch("setFolderId", "")
    this.openfolderlist = store.getters.getopenfolder;
    await this.getstudyinfo()
    await this.getTemplateList()
    await this.getStudyTemplateValue()
    await this.getTree()
    await this.setroleprivileges()
    this.defaultdate = localStorage.getItem("dateformat")

    window.addEventListener("studyIdChanged", async () => {
      this.folderType = ""
      this.isEditable = false
      this.selectedTemplate = ""
      this.hasChild = false
      this.folderlist = []
      this.showSelectTemplate = false
      store.dispatch("setFolderId", "")
      await this.getstudyinfo()
      await this.getStudyTemplateValue()
      await this.getTree()
      await this.getDocuments()
    })
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch("setopenfolder", "")
    next();
  },
  watch: {
    "$store.getters.getFolderName": function (val) {
      this.getDocuments();
      this.initializeColumns()
    },
    "$store.getters.getFolderId": async function (newVal) {

      this.bold = newVal;

      await this.getFolderbyId();

      // only artifact/sub-artifact nodes load docs
      if (this.isArtifactOrInsideArtifact) {

        await this.getDocuments(store.getters.getFolderId);

      }
      else {
        this.showTableLoading = false;
        this.documentList = [];

      }

      if (store.getters.getFolderId != '') {

        if (this.selectedFolderswitch[this.bold]) {
          this.selectedFolderswitch[this.bold] = !this.selectedFolderswitch[this.bold]
        }
        else {
          this.selectedFolderswitch[this.bold] = true
        }
      }
    },
  },

  computed: {
    showDetails() {
      return store.getters.getDetails;
    },
    folderNames() {
      this.setgetdetails();
      return store.getters.getFolderName;
    },
    lastModifiedAt() {
      return store.getters.getFolderdate;
    },
    canUploadDocuments() {

      const folderId = this.$store.getters.getFolderId;

      if (!folderId) return false;

      const node = this.folderLookup[folderId];

      if (!node) return false;

      // direct artifact
      if (node.type === "Artifact") {
        return true;
      }

      // check ancestors
      if (node.ancestorIds && node.ancestorIds.length) {

        return node.ancestorIds.some(id => {
          const parent = this.folderLookup[id];
          return parent && parent.type === "Artifact";
        });

      }

      return false;
    },
  },
  methods: {

    buildFolderLookup(nodes) {

      if (!nodes || !nodes.length) return;

      nodes.forEach(node => {

        this.folderLookup[node.id] = node;

        if (node.children && node.children.length) {
          this.buildFolderLookup(node.children);
        }

      });
    },

    //   setFolderDocCount(folderId, count) {
    //   if (!folderId) return;
    //   this.countsMap = Object.assign({}, this.countsMap, {
    //     [folderId]: Math.max(0, Number(count) || 0),
    //   });
    // },

    // NO '??' here
    // bumpFolderDocCount(folderId, delta) {
    //   var cur =
    //     (this.countsMap && this.countsMap.hasOwnProperty(folderId) && this.countsMap[folderId] != null)
    //       ? Number(this.countsMap[folderId])
    //       : 0;

    //   this.setFolderDocCount(folderId, cur + Number(delta || 0));
    // },

    // updateCountFromCurrentList() {
    //   var folderId = this.$store.getters.getFolderId;
    //   var count = Array.isArray(this.documentList) ? this.documentList.length : 0;
    //   this.setFolderDocCount(folderId, count);
    // },
    clickedOut(e) {
      if (e.relatedTarget.id === 'primary-tmf-tree') {
        store.dispatch("setFolderId", "");
      }
    },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    returnChild(value) {
      this.hasChild = value
    },
    returnRootType(value) {
      console.log("type is", value)
    },
    returnFolderType(value) {
      this.folderType = value
      console.log("type is", this.folderType)
      if (this.folderType != '' && this.folderType != undefined) {
        this.isEditable = false
      }
      else {
        this.isEditable = true
      }
    },
    async initializeColumns() {
      if (this.doclist.length > 0) {
        const allowedKeys = [
          "folderName",
          "documentName",
          "createdUsed",
          "CreatedAt"
        ];
        this.getColumns = Object.keys(this.doclist[0])
          .filter(column => allowedKeys.includes(column));
        const fieldLabels = {
          folderName: "Folder",
          documentName: "Document",
          createdUsed: "Created By",
          CreatedAt: "Created Date"
        }

        const readableData = allowedKeys.map(key => fieldLabels[key] || key);

        this.getColumns = readableData
        this.selectedColumns = [...this.getColumns];
        this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
          obj[key] = true;
          return obj;
        }, {});
      }
    },
    async setgetdetails() {
      if (store.getters.getFolderName) {
        this.savefolder = true;
      } else {
        this.savefolder = false;
      }
    },
    showTitleMore(index) {
      this.readTitleMore[index] = true;
    },
    showTitleLess(index) {
      this.readTitleMore[index] = false;
    },
    // async setroleprivileges() {
    //   this.roleprivileges = await store.getters.getRolesprivilegeData;
    // },
    /*Document upload functionality starts*/
    openDocumentModal() {
      this.uploadDocumentModal = true
      this.getStudyBasedUsers()
    },
    uploadDocumentModalClose() {
      this.list = []
      this.uploadDocumentModal = false
      this.documentEdit = false
      this.docTitle = ""
      this.docVersion = ""
      this.azuredata.Document = []
      this.documentValidationsError = [false, false, false]
      this.documentUploadFields = {
        folderid: "",
        title: "",
        description: "",
        owner: "",
        department: "",
        category: "",
        standard: "",
        documentType: "",
        version: "",
        expiryDate: "",
        formData: "",
        changesHistory: "",
        ExpectedCompletionDate: ""
      }
    },
    async loadfile() {
      let fileload = document.getElementById("InPutFile");
      fileload.click();
    },
    async previewFiles(event) {
      this.azuredata.Document = [];
      this.azuredata.Document.push(event.target.files);
      this.list = [...this.list, ...this.azuredata.Document[0]];
    },
    async validatedocument() {
      this.documentValidationsError = [false, false, false];



      if (store.getters.getFolderId.trim() == "") {
        this.documentValidationsError[0] = true;
        this.loadingDocUpload = false
      }

      if (this.azuredata.Document.length === 0 && this.documentEdit == false) {
        this.documentValidationsError[2] = true;
        this.loadingDocUpload = false
      }
      if (this.documentUploadFields.expiryDate != null) {
        if (new Date(this.documentUploadFields.expiryDate) < new Date()) {
          this.documentValidationsError[1] = true;
          this.loadingDocUpload = false
        }
      }
      if (this.documentUploadFields.ExpectedCompletionDate != null) {
        if (new Date(this.documentUploadFields.ExpectedCompletionDate) < new Date()) {
          this.documentValidationsError[3] = true;
          this.loadingDocUpload = false
        }
      }


    },
    async setCurrentUser(data) {
      console.log("logged", data);
      const idtoken = store.getters.getIdToken;
      const userEmail = jwt_decode(idtoken).email.trim();

      const userObject = data.find((item) => item.email?.trim() === userEmail);

      if (userObject) {
        this.currentUser = `${userObject.firstName} ${userObject.lastName}`;
        console.log("current user = ", this.currentUser);
        this.documentUploadFields.owner = this.currentUser;
      } else {
        console.warn(`No user found for email: ${userEmail}`);
        this.currentUser = null; // or fallback to first user if needed
      }
    },
    async submitFile() {
      const idtoken = store.getters.getIdToken;
      this.loadingDocUpload = true
      let vervalue = this.docVersion.toString();
      await this.validatedocument();
      if (!this.documentValidationsError.includes(true)) {
        if (this.documentEdit == false) {
          const uploadPromises = this.list.map(async (eachfiles) => {
            if (eachfiles.size == 0) {
              alert("Blank documents cannot be uploaded");
              this.loadingDocUpload = false
            } else {
              if (this.docTitle.trim() == "") {
                this.documentUploadFields.title = eachfiles.name;
              }
              if (this.documentUploadFields.owner.trim() == "") {
                this.documentUploadFields.owner = this.currentUser;
              }
              if (this.docTitle.trim() != "") {
                this.documentUploadFields.title = this.docTitle;
              }
              if (vervalue.trim() == "") {
                vervalue = "1";
              }
              const formData = new FormData();
              formData.append("DocumentDescription", this.documentUploadFields.description);
              formData.append("StudyId", store.getters.getStudyIs);
              formData.append("FolderId", store.getters.getFolderId ? store.getters.getFolderId.trim() : "");
              formData.append("File", eachfiles); // this is critical
              formData.append("Owner", this.documentUploadFields.owner);
              formData.append("ExpiryDate", this.documentUploadFields.expiryDate);
              formData.append("ExpectedCompletionDate", this.documentUploadFields.ExpectedCompletionDate ? this.documentUploadFields.ExpectedCompletionDate : "");
              formData.append("Version", vervalue ? vervalue.trim() : "");
              formData.append("DocumentTitle", this.documentUploadFields.title ? this.documentUploadFields.title.trim() : "");
              formData.append("VersionMessage", this.documentUploadFields.changesHistory);
              formData.append("StorageLocation", "TMF");
              return axios.post(
                `${this.baseurl}/etmf/document/uploaddocument`,
                formData,
                {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
            }
          })


          this.loadingDocUpload = true;

          try {
            await Promise.all(uploadPromises);
            const added = this.list.length;
            // this.bumpFolderDocCount(this.$store.getters.getFolderId, added);
            this.getTree();
            alert(this.$t("navigations.documents saved successfully"))
            this.uploadDocumentModalClose();
            this.getDocuments();
          } catch (err) {
            alert(err.message || "Failed to upload one or more documents.");
          } finally {
            this.loadingDocUpload = false;
          }
        }
        else {
          if (this.azuredata.Document != "") {
            if (confirm("Are you sure you want to replace the existing file?")) {
              await axios
                .put(
                  `${this.baseurl}/etmf/document/editdocument`,
                  {
                    "documentId": this.selectedDocument,
                    "folderId": store.getters.getFolderId,
                    "documentTitle": this.docTitle,
                    "documentDescription": this.documentUploadFields.description,
                    "changeHistory": this.documentUploadFields.changesHistory,
                    "owner": this.documentUploadFields.owner,
                    "department": "",
                    "catagory": "",
                    "standard": "",
                    "documentType": "",
                    "expiryDate": this.documentUploadFields.expiryDate ? this.documentUploadFields.expiryDate : null,
                    "expectedCompletionDate": this.documentUploadFields.ExpectedCompletionDate ? this.documentUploadFields.ExpectedCompletionDate : null,
                    "currentVersion": vervalue,
                    "isDeleted": false,
                    "status": "string",
                    "versionMessage": this.documentUploadFields.changesHistory,
                    "signers": [
                      {
                        "bookmark": "string",
                        "signOrder": "string",
                        "userId": "string",
                        "userEmail": "string",
                        "date": "2025-05-27T05:51:56.555Z",
                        "signId": "string",
                        "reason": "string",
                        "userName": "string",
                        "isSigned": true,
                        "signedDocId": "string"
                      }
                    ],
                    "studyId": store.getters.getStudyIs,
                    "artifactId": store.getters.getFolderId,
                    "effectiveDate": "2025-05-27T05:51:56.555Z",
                    "author": "",
                    "reviewDate": "2025-05-27T05:51:56.555Z",
                    "approvalDate": "2025-05-27T05:51:56.555Z",
                    "siteId": "",
                    "country": "",
                    "language": "",
                    "product": "",
                    "region": "",
                    "fileSize": "",
                    "checksum": ""
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  this.replaceFile()
                  alert("Document updated successfully");
                  this.uploadDocumentModalClose()
                  this.getDocuments()
                  this.loadingDocUpload = false

                })
                .catch((err) => {
                  this.loadingDocUpload = false
                });
            } else {
              this.loadingDocUpload = false
              return;
            }
          } else {
            await axios
              .put(
                `${this.baseurl}/etmf/document/editdocument`,
                {
                  "documentId": this.selectedDocument,
                  "folderId": store.getters.getFolderId,
                  "documentTitle": this.docTitle,
                  "documentDescription": this.documentUploadFields.description,
                  "changeHistory": this.documentUploadFields.changesHistory,
                  "owner": this.documentUploadFields.owner,
                  "department": "",
                  "catagory": "",
                  "standard": "",
                  "documentType": "",
                  "expiryDate": this.documentUploadFields.expiryDate ? this.documentUploadFields.expiryDate : null,
                  "currentVersion": vervalue,
                  "isDeleted": false,
                  "status": "",
                  "versionMessage": "",
                  "signers": [
                    {
                      "bookmark": "string",
                      "signOrder": "string",
                      "userId": "string",
                      "userEmail": "string",
                      "date": "2025-05-27T05:51:56.555Z",
                      "signId": "string",
                      "reason": "string",
                      "userName": "string",
                      "isSigned": true,
                      "signedDocId": "string"
                    }
                  ],
                  "studyId": store.getters.getStudyIs,
                  "artifactId": store.getters.getFolderId,
                  "effectiveDate": "2025-05-27T05:51:56.555Z",
                  "author": "",
                  "reviewDate": "2025-05-27T05:51:56.555Z",
                  "approvalDate": "2025-05-27T05:51:56.555Z",
                  "siteId": "",
                  "country": "",
                  "language": "",
                  "product": "",
                  "region": "",
                  "fileSize": "",
                  "checksum": ""
                },
                {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                alert("Document updated successfully");
                this.uploadDocumentModalClose()
                this.getDocuments()
                this.loadingDocUpload = false
              })
              .catch((err) => {
                this.loadingDocUpload = false
              });
          }

        }
      }
    },
    async replaceFile() {
      const idtoken = store.getters.getIdToken;
      if (this.azuredata.Document != "") {
        if (this.documentUploadFields.version.trim() == "") {
          this.documentUploadFields.version = "1";
        }
        const formData = new FormData();


        for (let i = 0; i < this.azuredata.Document[0].length; i++) {
          formData.append('File', this.azuredata.Document[0][i]);
        }


        formData.append('DocumentId', this.selectedDocument);
        formData.append('ExpiryDate', this.documentUploadFields.expiryDate);
        formData.append('VersionMessage', this.documentUploadFields.changesHistory);
        formData.append('Version', this.documentUploadFields.version.trim());
        formData.append('StudyId', store.getters.getStudyIs);
        await axios
          .post(
            `${this.baseurl}/etmf/document/updatefile`,
            formData,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            this.getDocuments();
            console.log("replace response", response);
          })
          .catch((err) => {
            console.log(err.data);
          });
      }
    },
    async removefile(index) {
      this.list.splice(index, 1)
    },

    async openSidePopup(id) {
      this.showDocLoading[id] = true
      this.selectedDocument = id
      await this.getDocumentdetails(id);
    },
    async getDocumentdetails(id) {
      this.sendtoValue = "";
      this.editValue = "";
      this.permissionsValue = "";
      this.shareValue = "";
      this.deleteValue = "";
      this.archiveValue = "";
      this.viewValue = "";
      this.deleteValue = "";
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.document.userPermission[0].permission != null) {
            this.anyuserpermissions = false;

            res.data.document.userPermission[0].permission.forEach((item) => {
              if (item == "View") this.viewValue = item;
              if (item == "Clone") this.sendtoValue = item;
              if (item == "Permissions") this.permissionsValue = item;
              if (item == "Share") this.shareValue = item;
              if (item == "Edit") this.editValue = item;
              if (item == "Delete") this.deleteValue = item;
              if (item == "Archive") this.archiveValue = item;
              if (item == "Download") this.downloadValue = item;
            });
            if (
              !this.viewValue ||
              !this.sendtoValue ||
              !this.permissionsValue ||
              !this.shareValue ||
              !this.editValue ||
              !this.deleteValue ||
              !this.archiveValue ||
              !this.downloadValue
            ) {
              this.anyuserpermissions = true;
            }
          } else {
            this.anyuserpermissions = true;
          }
          this.showDocLoading[id] = false;
          // this.getVersionHistory();
        })
        .catch((err) => {
          this.showDocLoading[id] = false;
          console.log(err);
        });
    },
    async getDocuments() {
      this.documentlist = []
      const idtoken = store.getters.getIdToken;
      this.showTableLoading = true
      if (store.getters.getFolderId != '') {
        await axios
          .get(
            `${this.baseurl}/etmf/folder/getprivilegedcontent?Id=${store.getters.getFolderId}&StudyId=${store.getters.getStudyIs}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.showTableLoading = false
            this.documentList = res.data;
            // this.updateCountFromCurrentList();
            if (this.documentList != null && this.documentList.length != 0) {
              this.documentList.forEach((item) => {
                this.showDocLoading[item.id] = false
              })
            }
          })
          .catch((err) => {
            console.log(err);
            this.showTableLoading = false
          });

      }
      else {
        this.showTableLoading = false
        this.documentList = []
      }

    },
    showMore(index) {
      this.readMore[index] = true;
    },
    showLess(index) {
      this.readMore[index] = false;
    },
    /*Edit document functionality starts*/
    async editDocument(documentId, id, version) {
      await this.closePopover(id)
      this.documentEdit = true
      this.uploadDocumentModal = true
      this.documentLoader = true
      await this.getStudyBasedUsers()
      await this.getDocumentDetails(documentId, version)
      this.documentLoader = false

    },
    async getDocumentDetails(documentId, version) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${documentId}&version=${version}`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getDocumentData = res.data;
          const doc = res.data.document;

          this.currentVersion = doc.currentVersion;

          if (doc.documentVersions && doc.documentVersions.length) {
            const latestVer = doc.documentVersions[doc.documentVersions.length - 1];
            this.getLatestVersionMsg = latestVer.versionMessage;
            this.latestver = latestVer.version;
          }

          this.setData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setData() {
      const doc = this.getDocumentData.document;

      this.docFolder = doc.folderId;
      this.docTitle = doc.documentTitle;
      this.documentUploadFields.description = doc.documentDescription || '';
      this.documentUploadFields.owner = doc.owner;
      this.documentUploadFields.expiryDate = doc.expiryDate
        ? doc.expiryDate.slice(0, 10)
        : "";
      this.documentUploadFields.changesHistory = doc.changeHistory || '';


      this.docVersion = doc.currentVersion
        || (doc.documentVersions && doc.documentVersions.length
          ? doc.documentVersions[doc.documentVersions.length - 1].version
          : "");


      var latestVersion = doc.documentVersions && doc.documentVersions.length
        ? doc.documentVersions[doc.documentVersions.length - 1]
        : null;
      this.documentUploadFields.ExpectedCompletionDate = latestVersion && latestVersion.expectedCompletionDate
        ? latestVersion.expectedCompletionDate.slice(0, 10)
        : "";
    },
    // async setData() {
    //   // this.getDocumentData.expiryDate != null
    //   //   ? (this.getDocumentData.expiryDate = this.getDocumentData.expiryDate.slice(0, 10))
    //   //   : this.getDocumentData.expiryDate;
    //   this.docFolder = this.getDocumentData.folderId;
    //   this.docTitle = this.getDocumentData.documentTitle;
    //   this.documentUploadFields.description =
    //     this.getDocumentData.documentDescription != null ? this.getDocumentData.documentDescription : '';
    //   this.documentUploadFields.owner = this.getDocumentData.owner;
    //   // this.documentUploadFields.Department = this.getDocumentData.department;
    //   // this.documentUploadFields.Category = this.getDocumentData.catagory;
    //   // this.documentUploadFields.Standard = this.getDocumentData.standard;
    //   // this.documentUploadFields.documenttype = this.getDocumentData.documentType;
    //   this.docVersion = this.getDocumentData.latestVersion;
    //   this.documentUploadFields.expiryDate = this.getDocumentData.expiryDate ? this.getDocumentData.expiryDate.slice(0, 10) : "";
    //   this.documentUploadFields.changesHistory = this.getDocumentData.changeHistory;
    // },
    async viewDocument(id, name, version) {
      console.log("id", id)
      this.$router.push(`/documentview/${id}/${version}`)
    },
    /*Edit document functionality ends*/
    /*View document functionality starts*/
    async closeViewDocumentModal(id, name) {
      this.openFileViewModal = false
      this.format = ""
      this.source = ""
      this.documentName = ""
    },
    async setDoc(id) {
      this.source = `${this.baseurl}/etmf/document/getdocument?documentId=${id}`
      this.officeurl = `https://view.officeapps.live.com/op/embed.aspx?src=${this.source}`;
    },
    /*View document functionality ends*/
    async archiveDocument(id, documentId) {
      await this.closePopover(id)
      const idtoken = store.getters.getIdToken;
      if (confirm(this.$t('navigations.are you sure you want to archive this document'))) {
        await axios
          .put(
            `${this.baseurl}/etmf/document/archivedocument?id=${documentId}`, {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            // this.bumpFolderDocCount(this.$store.getters.getFolderId, -1);
            this.getTree();
            alert(this.$t('navigations.document archived successfully'))
            this.getDocuments()
          })
          .catch((err) => {
            console.log(err);
            this.showTableLoading = false
          });
      }
    },
    async downloadDocument(id, documentId, name) {
      await this.closePopover(documentId)
      const res = await fetch(`${this.baseurl}/etmf/document/getdocument?documentId=${id}`);
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name; // this will now be respected
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      alert(this.$t('navigations.document downloaded successfully'))

    },
    async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*Tree generation functionalitites starts*/
    async getTemplateList() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/gettmftemplates`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.templateList = res.data
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async generateTree() {
      if (this.selectedTemplate === '') {
        alert(this.$t('navigations.please select a template'));
      }
      if (store.getters.getStudyIs == null || store.getters.getStudyIs == 'null') {
        alert(this.$t('navigations.please select a study'));
      }
      if (this.selectedTemplate != '' && store.getters.getStudyIs != null && store.getters.getStudyIs != 'null') {
        const idtoken = store.getters.getIdToken;
        this.loadingGenerateBtn = true
        this.showTreeLoading = true
        await axios
          .post(`${this.baseurl}/etmf/folder/generatefolder/${this.selectedTemplate}?studyName=${this.studyInfo.studyRef}&StudyId=${store.getters.getStudyIs}`, {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.loadingGenerateBtn = false
            this.getTree()
            this.getStudyTemplateValue()
          })
          .catch((err) => {
            this.loadingGenerateBtn = false
            this.showTreeLoading = false
            if (err && err.response && err.response.data && err.response.data.detail == "This template has already been used to create the TMF folder structure for the selected study.") {
              alert(this.$t('navigations.this template has already been used to create the TMF folder structure for the selected study'))
            }
          });
      }

    },
    /*Tree generation functionalitites end*/
    /*Add folder functionalitites starts*/
    async createFolderfunc(value) {
      this.values.FolderName = ""
      this.values.Approver = [];
      if (store.getters.getFolderId == '') {
        this.folderType = ""
        this.isEditable = true
      }
      else if (this.folderType != '' && this.folderType != undefined) {
        this.isEditable = false
      }
      if (value == "addRoot" || value == 'addSubFolder') {
        this.folderbyid.name = ""
        this.selectedFolderValue = "addRoot"
        this.showFolder = !this.showFolder;
      }
    },
    addFolderModalClose() {
      this.values.FolderName = "";
      this.showFolder = false
      this.editFolderErrors = [false, false, false, false]
    },
    async addFolder(type) {
      const idtoken = store.getters.getIdToken;
      let folderId = store.getters.getFolderId;
      this.loadingEditFolder = true
      await this.validate();
      if (this.selectedFolderValue == 'addRoot') {
        if (!this.editFolderErrors.includes(true)) {
          await axios
            .post(`${this.baseurl}/etmf/folder/createtmffolder`, {
              "name": this.updateFolder.folderName,
              "studyName": this.studyInfo.studyName,
              "parentId": folderId ? folderId : this.parentFolderId ? this.parentFolderId : '',
              "storageId": "",
              "storageType": "General",
              "fileConfiguration": this.SelectedFormat,
              "versionConfiguration": [
                {
                  "prefix": this.prefix,
                  "majorVerStart": this.majorVerStart,
                  "minorVerStart": this.minorVerStart,
                  "minorVermax": this.minorVermax
                }],
              "ancestorIds": [
                "string"
              ],
              "studyId": store.getters.getStudyIs,
              "type": this.folderType
            }, {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              alert(this.$t("navigations.folder created successfully"));
              this.getStudyTemplateValue();
              this.getTree();
              store.dispatch("setFolderId", folderId);
              if (folderId) {
                document.getElementById("etmf-" + folderId).click();
                document.getElementById("etmf-" + folderId).click();
              }
              else {
                this.getTree()
              }
              this.addFolderModalClose()
              this.loadingEditFolder = false

            })
            .catch((err) => {
              this.loadingEditFolder = false
              console.log(err.response);
              if (err.response && err.response.data.errors && err.response.data.errors.DomainValidations[0] == 'Folder name already present in the parent folder.') {
                alert(this.$t('navigations.folder name already present in the parent folder'))
              }
            });
        }
      }
    },
    async addSubFolder() {
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      await this.getFolderbyId();
      this.values.ParentId = folderId;
      this.values.storageId = "general";
      this.values.AncestorIds = [folderId];
      this.folderbyid.ancestorIds.forEach((element) => {
        const index = this.folderbyid.ancestorIds.indexOf(element);
        this.values.AncestorIds[index + 1] = this.folderbyid.ancestorIds[index];
      });
      await this.validateIsNull();
      if (this.errors[0]) {
        this.trim();
        await axios
          .post(
            `${this.baseurl}/management/folder/create`,
            this.values,

            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res);
            alert(this.$t("navigations.folder created successfully"));
            this.showFolder = false;
            this.values.FolderName = "";
            document.body.style.overflowY = "auto";
            this.getfolder("general");
          })
          .catch((err) => {
            console.log(err);
            alert(this.$t("navigations.folder name already exists"));
          });
      }
    },
    /*Add folder functionalitites end*/
    /*Edit folder functionalities starts*/
    async editFolder(id) {
      this.editFolderModal = true
      this.getFolderbyId()
    },
    editFolderModalClose() {
      this.editFolderModal = false
      this.loadingEditFolder = false
      this.folderType = ""
      this.folderbyid.name = ""
      this.editFolderErrors = [false, false, false, false]
    },
    async hasArtifactAncestor(ancestorIds) {

      if (!ancestorIds || !ancestorIds.length) {
        return false;
      }

      const idtoken = store.getters.getIdToken;

      for (const id of ancestorIds) {

        try {

          const res = await axios.get(
            `${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );

          if (res.data && res.data.type === "Artifact") {
            return true;
          }

        } catch (err) {
          console.log(err);
        }

      }

      return false;
    },
    async getFolderbyId() {
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getfolderbyid?Id=${folderId}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {

          this.folderbyid = res.data;
          this.folderType = res.data.type;

          // direct artifact
          if (res.data.type === "Artifact") {

            this.isArtifactOrInsideArtifact = true;

          }
          else {

            this.isArtifactOrInsideArtifact =
              await this.hasArtifactAncestor(res.data.ancestorIds);

          }

        })
        .catch((err) => {
          this.isArtifactOrInsideArtifact = false;
          console.log(err);
        });
    },
    async updatefolder(name, type) {
      this.loadingEditFolder = true
      const folderId = store.getters.getFolderId;
      const idtoken = store.getters.getIdToken;
      this.updateFolder.id = folderId;
      this.updateFolder.ancestorIds = this.folderbyid.ancestorIds;
      this.updateFolder.parentId = this.folderbyid.parentId;
      this.updateFolder.storageId = "General";
      await this.validate();
      if (!this.editFolderErrors.includes(true)) {
        await axios
          .put(`${this.baseurl}/etmf/folder/updatefolder?Id=${folderId}`,
            {
              "name": this.updateFolder.folderName,
              "storageId": "string",
              "storageType": this.updateFolder.storageId,
              "fileConfiguration": [
                "string"
              ],
              "versionConfiguration": [
                {
                  "prefix": this.prefix,
                  "majorVerStart": this.majorVerStart,
                  "minorVerStart": this.minorVerStart,
                  "minorVermax": this.minorVermax
                }
              ],
              "studyId": store.getters.getStudyIs,
              "type": this.folderType
            }, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            alert(this.$t("navigations.folder updated successfully"));
            this.loadingEditFolder = false
            this.editFolderModalClose();
            this.getfolderslastancestor(store.getters.getFolderId);
            if (this.lastAncestor == "") {
              this.folderlist.forEach((element) => {
                if (element.id == store.getters.getFolderId) {
                  element.name = name
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.loadingEditFolder = false
            alert(this.$t("navigations.folder name already exist"));
          });
      }
    },
    updateFolderNameInTree(folderId, updatedName) {
      const updateName = (list) => {
        if (!list || !Array.isArray(list)) return;
        for (const item of list) {
          if (item.id === folderId) {
            item.name = updatedName;
            return;
          }
          if (item.children) {
            updateName(item.children);
          }
        }
      };
      for (const key in this.folderlist) {
        updateName(this.folderlist[key]);
      }
    },
    async getfolderslastancestor(id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let editedfolderdetails = [];
          editedfolderdetails = res.data.ancestorIds;
          this.lastAncestor =
            editedfolderdetails[editedfolderdetails.length - 1];
          if (this.lastAncestor != '' && this.lastAncestor != undefined) {
            document.getElementById("etmf-" + this.lastAncestor).click();
            document.getElementById("etmf-" + this.lastAncestor).click();
            document.getElementById("etmf-" + res.data.id).click();
          }
          else {
            this.lastAncestor = ""
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },
    /*Edit Folder functionalities end*/
    /*Folder tree functionalities starts*/
    async getStudyTemplateValue() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/isetmfgenerated?studyid=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((res) => {
          console.log("ressssssssss", res.data)
          if (res.data == true) {
            this.showSelectTemplate = false
          }
          else {
            this.showSelectTemplate = true
          }

        })
        .catch((err) => {
          console.log(err)

        })

    },
    setNodeCounts(nodes) {
      if (!Array.isArray(nodes)) return;

      nodes.forEach(node => {
        this.countsMap[node.id] = node.documentCount || 0;
      });
    },
    async getTree() {
      this.showTreeLoading = true
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getprivilegedroots?storageType=General&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
        .then((res) => {
          this.showTreeLoading = false
          this.folderlist = res.data;

          //new change
          const roots = res.data;

          this.setNodeCounts(roots);

          this.folderlist = roots;
          this.folderLookup = {};
          this.buildFolderLookup(this.folderlist);

          //new change ends

          if (this.folderlist.length != 0) {
            this.showSelectTemplate = false
            const rootFolder = this.folderlist.find(item => item.type === 'Root')
            if (rootFolder) {
              this.parentFolderId = rootFolder.id;
              this.getFolderChildren(rootFolder.id);
            }
          }
          else {
            this.parentFolderId = "";
            this.showSelectTemplate = true
          }
        })
        .catch((err) => {
          this.showTreeLoading = false
          console.log(err.response.data.messages)
        })

    },
    async getFolderChildren(id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${id}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.length != 0) {
            //new code
            const children = res.data;

            this.setNodeCounts(children);
            //new code ends
            if (res.data[0].type) {
              this.folderType = res.data[0].type
            }
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    /*Folder Tree functionalities */
    /*Delete Folder functionalities */
    async deleteFolder(ancestorIds) {
      const folderId = store.getters.getFolderId;
      if (
        confirm(
          this.$t("navigations.are you sure you want to delete this folder?")
        )
      ) {
        if (
          confirm(
            this.$t("navigations.all the folders and documents under this folder will be deleted")
          )
        ) {
          const idtoken = store.getters.getIdToken;
          this.initialLoader = true
          this.process = "deleted"
          await axios
            .delete(
              `${this.baseurl}/etmf/folder/deletefolder?Id=${folderId}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              alert(this.$t("navigations.folder deleted successfully"));
              if (ancestorIds.length === 0) {
                store.dispatch("setFolderId", "");
              } else {
                this.lastAncestor = ancestorIds.pop();
                store.dispatch("setFolderId", this.lastAncestor);
              }
              this.folderlist.forEach((element) => {
                if (element.id == folderId) {
                  let index = this.folderlist.indexOf(element);
                  this.folderlist.splice(index, 1);
                }
              });
              if (this.folderlist.length == 0) {
                this.parentFolderId = ""
                this.showSelectTemplate = true
                this.selectedTemplate = ""
                this.folderType = ""
                this.isEditable = false
              }
              document.getElementById("etmf-" + this.lastAncestor).click();
              document.getElementById("etmf-" + this.lastAncestor).click();
              store.dispatch("setFolderId", "");
              this.initialLoader = false
            })
            .catch((err) => {
              this.initialLoader = false
              console.log(err)
            })
        }
      }
    },
    /*Delete Folder functionalities ends*/
    /*Archive Folder functionalities start*/
    async archiveFolder() {
      const folderId = store.getters.getFolderId;
      if (
        confirm(
          this.$t("navigations.are you sure you want to archive this folder")
        )
      ) {
        const idtoken = store.getters.getIdToken;
        await axios
          .put(
            `${this.baseurl}/etmf/folder/archivefolder?id=${folderId}&StudyId=${store.getters.getStudyIs}`,
            {},
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            alert(this.$t("navigations.folder archived successfully"));
            this.getfolderslastancestor(store.getters.getFolderId);
            if (this.lastAncestor == "") {
              this.folderlist.forEach((element) => {
                if (element.id == store.getters.getFolderId) {
                  let index = this.folderlist.indexOf(element);
                  this.folderlist.splice(index, 1);
                }
              });
            }
          })
          .catch((err) => {
            if (
              err.response.data.messages[0].includes(
                "This folder contains 1 or more subfolders, folder with subfolders cannot be deleted"
              )
            ) {
              alert(
                this.$t("navigations.this folder contains 1 or more subfolders, folder with subfolders cannot be deleted")
              );
            }
            if (
              err.response.data.messages[0].includes(
                "This folder contains 1 or more documents, folder with document cannot be deleted"
              )
            ) {
              alert(
                this.$t("navigations.this folder contains 1 or more documents, folder with document cannot be deleted")
              );
            }
          });
      }
    },
    /*Archive Folder functionalities end*/
    /*Clone folder functionalities starts*/
    openCloneFolder(name) {
      this.newFolderName = name
      this.cloneFolderModal = true
    },
    cloneFolderModalClose() {
      this.cloneFolderModal = false
      this.cloneType = ""
      this.newFolderName = ""
      store.dispatch("setFolderMoveId", "");
    },
    getName(name) {
      this.newFolderName = name
    },

    async cloneFolder() {
      const folderMoveId = store.getters.getFolderMoveId;
      const folderId = store.getters.getFolderId
      if (this.cloneType == '' || store.getters.getFolderMoveId == '') {
        if (this.cloneType == '') {
          alert(this.$t('navigations.please choose an action before clone'))
        }
        if (store.getters.getFolderMoveId == '') {
          alert(this.$t('navigations.please choose an target folder before clone'))
        }
      }
      else {
        if (
          confirm(
            this.$t("navigations.are you sure you want to clone this folder")
          )
        ) {
          const idtoken = store.getters.getIdToken;
          this.loadingCloneFolder = true
          await axios
            .get(
              `${this.baseurl}/etmf/folder/copyfolder?FolderId=${folderId}&TargetId=${folderMoveId}&NewName=${this.newFolderName}&CloneType=${this.cloneType}&StudyId=${store.getters.getStudyIs}`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
              this.loadingCloneFolder = false
              alert(this.$t("navigations.folder cloned successfully"));
              if (this.selectedFolderswitch[folderMoveId]) {
                document.getElementById("etmf-" + folderMoveId).click();
                document.getElementById("etmf-" + folderMoveId).click();
              }
              else {
                document.getElementById("etmf-" + folderMoveId).click();
              }
              this.cloneFolderModalClose()
            })
            .catch((err) => {
              this.loadingCloneFolder = false
              if (
                err.response.data ==
                "Subfolder with new name exist in targeted folder"
              ) {
                alert(
                  this.$t("navigations.subfolder with new name exist in targeted folder")
                );
              }
              if (
                err.response.data == "Subfolder with same name exist in targeted folder") {
                alert(
                  this.$t("navigations.subfolder with same name exist in targeted folder")
                );
              }
              if (
                err.response.data ==
                "Cannot move folder inside itself"
              ) {
                alert(
                  this.$t("navigations.cannot move folder inside itself")
                );
              }

            });
        }
      }

    },
    /*Clone folder functionalities end*/
    /*Export folder functionalities starts*/
    async exportFolder(name) {
      this.process = "exported"
      this.initialLoader = true
      const folderId = store.getters.getFolderId
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/exportfolder?exportfolderId=${folderId}&StudyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          const contentDisposition = res.headers["content-disposition"];
          let fileName = `${name}.zip`;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1]);
            }
          }

          // Create a link and trigger the download
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          alert(this.$t("navigations.folder exported successfully"));
          this.initialLoader = false

        })
        .catch((err) => {
          this.initialLoader = false
          console.error("err", err)

        });

    },
    /*Export folder functionalities end*/
    /*Export folder tree structure functionalities starts*/
    async exportTreeFolderStructure(name) {
      this.initialTreeDownloader = true
      const folderId = store.getters.getFolderId
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/etmf/folder/gettmffolderstructure/${folderId}?folderName=${name}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "text/plain",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let fileName = `${name}.xlsx`; // fallback filename
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          alert(this.$t("navigations.folder exported successfully"));
          this.initialTreeDownloader = false

        })
        .catch((err) => {
          this.initialTreeDownloader = false
          console.error("err", err)

        });

    },
    /*Export folder tree structure  functionalities end*/
    getupdatedfolder(doctype) {
      this.showTreeLoading = true
      this.folderlist = [];
      const idtoken = store.getters.getIdToken;
      axios
        .get(
          `${this.baseurl}/management/folder/listfolder?storageId=${doctype}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.folderlist = res.data;
          this.showTreeLoading = false
        });
    },
    async validate() {
      this.editFolderErrors = [false, false, false]
      this.updateFolder.folderName = this.folderbyid.name ? this.folderbyid.name.replace(/ +/g, ' ').trim() : ''
      this.folderType = this.folderType ? this.folderType.replace(/ +/g, ' ').trim() : ''
      if (this.updateFolder.folderName == "") {
        this.editFolderErrors[0] = true;
        this.folderErrorMessages[0] = "Please enter a folder name";
        this.loadingEditFolder = false
      }
      else if (this.updateFolder.folderName.length > 75) {
        this.editFolderErrors[0] = true;
        this.folderErrorMessages[0] = "Maximum number of character is 75";
        this.loadingEditFolder = false
      }
      if (this.hasChild == false && this.folderType == "") {
        this.editFolderErrors[1] = true;
        this.loadingEditFolder = false
      }
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z]+$/.test(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },
    isNumber: function (evt, vtype) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      const getmaj = vtype;
      if (getmaj == 'major') {
        if (this.majorVerStart.length == 0 && charCode == 48) {
          evt.preventDefault();
        }
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }

    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
    SortSelected(sortProp, id) {
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.getDocuments();
    },
    /*Folder and file functionalities starts*/
    async addFolderPermission(type, id, documentId) {
      await this.closePopover(id)
      this.initialPermissionLoader = true
      this.selectedDocument = documentId
      this.source = type
      this.designation = []
      this.userList = []
      this.selectedRole = []
      this.userobject = {}
      await this.listRoles()
      if (this.source == 'File') {
        this.initialPermissionLoader = false
        this.openDocsPermissionModal = true
        await this.getAllFilePermission();
      }
      else {
        this.initialPermissionLoader = false
        this.openPermissionModal = true
        await this.getAllFolderPermission();
      }
    },
    permissionModalClose(type) {
      if (type == 'File') {
        this.openDocsPermissionModal = false
      }
      else {
        this.openPermissionModal = false
      }

    },
    async closePopover(id) {
      document.getElementById(id) ? document.getElementById(id).hidePopover() : null
    },
    async listRoles() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/roles/search?`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.data != null && res.data.data != undefined && res.data.data.length != 0) {
            this.roleList = res.data.data.sort((a, b) => a.role_Name.localeCompare(b.role_Name))
          }
        })
        .catch((err) => {
          console.error(err)
        });
    },
    setofpermissions() {
      this.permissionList.forEach((permissions) => {
        this.permissionset.push(permissions.permission);
      })
    },
    async setcontrols(elements) {
      let checkBox = document.getElementById(elements.userID);
      if (checkBox.checked == true) {
        this.userobject[elements.userID].permission = this.permissionset;

      } else {
        if (elements.userID in this.userobject) {
          this.userobject[elements.userID].permission = [];
        }
      }
    },
    async setpermissions(permission) {
      let permissioncheckBox = document.getElementById(permission);
      if (permissioncheckBox.checked == true) {
        this.userList.forEach((users) => {
          if (!this.userobject[users.userID].permission.includes(permission)) {
            this.userobject[users.userID].permission.push(permission);
          }
        })
      } else {
        this.userList.forEach((users) => {
          if (this.userobject[users.userID].permission.includes(permission)) {
            var index = this.userobject[users.userID].permission.indexOf(permission);
            if (index !== -1) {
              this.userobject[users.userID].permission.splice(index, 1);
            }
          }
        })
      }
    },
    async selectall() {
      let checkBoxall = document.getElementById("selectall");
      if (checkBoxall.checked == true) {
        this.userList.forEach((users) => {
          this.userobject[users.userID].permission = this.permissionset;
        })
      } else {
        this.userList.forEach((users) => {
          this.userobject[users.userID].permission = [];
        })
      }
    },
    async onChange(event, type) {
      console.log(event, type)
      this.showSave = true
      if (type == 'file' || type == 'folder') {
        this.selectedRole = event;
      }
      else {
        this.selectedRole[0] = event.target.value;
      }

      if (event.length != 0) {
        await this.getDesignationUser('Permission', type)
        this.permissionset = [];
      }
      else {
        this.userList = []
      }
    },
    async getDesignationUser(type, docId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .post(`${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
          type == 'Permission' ? this.selectedRole : [],
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.userList = res.data;
          if (type == 'Permission') {
            this.setUsersInArray();
            this.getAllPermissions();
            this.getPermissionById(docId);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getStudyBasedUsers(type) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          if (res.data.entities != null && res.data.entities != undefined && res.data.entities.length != 0) {
            this.ownerList = res.data.entities.sort((a, b) => a.firstName.localeCompare(b.firstName))
          }
          this.setCurrentUser(this.ownerList)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setUsersInArray() {
      this.userobject = [];
      this.userList.forEach((eachusers) => {
        if (this.source == 'File') {
          let userinformations = {
            "permissionType": "Designation",
            "permissionId": eachusers.roleId,
            "userId": eachusers.userID,
            "emailId": eachusers.email,
            "name": eachusers.name,
            "permission": [],
            "userName": eachusers.userName
          };
          this.loadingPermission[eachusers.userID] = false
          this.userobject[eachusers.userID] = userinformations;
        }
        else {
          let userinformations = {
            "permissionType": "Designation",
            "permissionId": eachusers.roleId,
            "userId": eachusers.userID,
            "emailId": eachusers.email,
            "name": eachusers.name,
            "permission": [],
            "userName": eachusers.userName
          };
          this.loadingPermission[eachusers.userID] = false
          this.userobject[eachusers.userID] = userinformations; ``
        }

      });
    },
    selectuserwithpermission(userid) {
      let checkBox = "";
      checkBox = document.getElementById(userid);
      if ((this.userobject[userid].permission).length != 0) {
        checkBox.checked = true;
      }
    },
    async getAllPermissions() {
      if (this.source == "File") {
        await this.getAllFilePermission();
      }
      else {
        await this.getAllFolderPermission();
      }

    },
    async getPermissionById() {
      if (this.source == "File") {
        await this.getFilePermissionbyId();
      }
      else {
        await this.getFolderPermissionById();
      }
    },
    async getAllFolderPermission() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folderfilepermission/allfolderpermission`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.permissionList = res.data;
          this.setofpermissions();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getAllFilePermission() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folderfilepermission/allfilepermission`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.permissionList = res.data;
          this.setofpermissions();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFolderPermissionById() {
      const idtoken = store.getters.getIdToken;
      await axios
        .post(`${this.baseurl}/etmf/folderfilepermission/getfolderpermissions?FolderId=${store.getters.getFolderId}`,
          this.selectedRole
          ,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.folderPermissionList = res.data;
          this.retrievePermission();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFilePermissionbyId() {
      const idtoken = store.getters.getIdToken;
      await axios
        .post(`${this.baseurl}/etmf/folderfilepermission/getfilepermission?documentId=${this.selectedDocument}`,
          this.selectedRole
          ,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          this.folderPermissionList = res.data;
          this.retrievePermission();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async retrievePermission() {
      if (this.folderPermissionList.length != 0) {
        await this.folderPermissionList.forEach((element) => {
          this.userobject[element.userId].permission = element.permission;
        });
      }

    },
    async saveSinglePermission(type, id) {
      this.loadingPermission[id] = true
      const idtoken = store.getters.getIdToken;
      if (type == 'folder') {
        let savedata = {
          "folderId": store.getters.getFolderId,
          "userPermission": this.userobject[id]
        };
        await axios
          .post(`${this.baseurl}/etmf/folderfilepermission/singlesavefolder`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.loadingPermission[id] = false
            alert("Permission added successfully");
          })
          .catch((err) => {
            this.loadingPermission[id] = false
            console.log(err);
          });
      }
      else {
        let savedata = {
          "documentId": this.selectedDocument,
          "userPermission": this.userobject[id]
        };
        await axios
          .post(`${this.baseurl}/etmf/folderfilepermission/singlesavefile`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.loadingPermission[id] = false
            alert("Permission added successfully");
          })
          .catch((err) => {
            this.loadingPermission[id] = false
            console.log(err);
          });
      }


    },
    async multiSavePermission(type) {
      this.loadingSaveModalBtn = true
      if (type == 'folder') {
        let savedata = {
          "folderId": store.getters.getFolderId,
          "userPermission": Object.values(this.userobject)
        };
        if (savedata.userPermission.length != 0) {
          const idtoken = store.getters.getIdToken;
          await axios
            .post(`${this.baseurl}/etmf/folderfilepermission/multiplesavefolder`, savedata
              , {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              })
            .then((res) => {
              this.userListsss = res.data;
              this.loadingSaveModalBtn = false
              alert("Permission added successfully");
              this.permissionModalClose();
            })
            .catch((err) => {
              this.loadingSaveModalBtn = false
              console.log(err);
            });
        }
      }
      else {
        let savedata = {
          "documentId": this.selectedDocument,
          "userPermission": Object.values(this.userobject)
        };
        if (savedata.userPermission.length != 0) {
          const idtoken = store.getters.getIdToken;
          await axios
            .post(`${this.baseurl}/etmf/folderfilepermission/multiplesavefile`, savedata
              , {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              })
            .then((res) => {
              this.userListsss = res.data;
              this.loadingSaveModalBtn = false
              alert("Permission added successfully");
              this.permissionModalClose('File');
            })
            .catch((err) => {
              this.loadingSaveModalBtn = false
              console.log(err);
            });
        }
      }
    },

    /*Folder and file functionalities end*/
    /*File delete functionalities start*/
    async deleteDocument(documentId, id) {
      await this.closePopover(id)
      const idtoken = store.getters.getIdToken;
      if (confirm(this.$t('navigations.are you sure you want to delete this document'))) {
        await axios
          .delete(`${this.baseurl}/etmf/document/deletedocument?documentId=${documentId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            // this.bumpFolderDocCount(this.$store.getters.getFolderId, -1);
            this.getTree();
            alert(this.$t('navigations.document deleted successfully'))
            this.getDocuments()
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /*File delete functionalities end*/
    /*Folder/File share functionalities start*/
    async shareFolderPermission(type, id, docId) {
      let documentId = id;

      this.initialPermissionLoader = true
      this.source = type
      this.designation = []
      this.userList = []
      this.selectedRole = []
      this.userobject = {}
      this.selectedDocument = docId
      await this.listRoles()
      this.source = type
      if (this.source == 'File') {
        await this.closePopover(id)
        this.initialPermissionLoader = false
        this.documentIdd = documentId.replace("tmf-docs-", "");
        this.openFileShareModal = true
        await this.getAllFilePermission();

      }
      else {
        this.initialPermissionLoader = false
        this.openFolderShareModal = true
        await this.getAllFolderPermission();

      }
    },
    closeShareFolderPermission(type) {
      if (type == 'File') {
        this.openFileShareModal = false
      }
      else {
        this.openFolderShareModal = false
      }

    },
    async multiSaveShare(type) {
      const idtoken = store.getters.getIdToken;
      this.source = type
      this.loadingSaveModalBtn = true
      if (type == 'Folder') {
        let savedata = {
          "folderId": store.getters.getFolderId,
          "type": this.source,
          "department": "",
          "studyId": store.getters.getStudyIs,
          "userPermission": Object.values(this.userobject)
        };

        await axios
          .post(`${this.baseurl}/etmf/folder/sharefolder`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.userListsss = res.data;
            alert("Folder shared successfully");
            this.loadingSaveModalBtn = false
            this.closeShareFolderPermission();
          })
          .catch((err) => {
            console.log(err);
            this.loadingSaveModalBtn = false
          });
      }
      else {
        let savedata = {
          "documentId": this.selectedDocument,
          "version": "",
          "studyId": store.getters.getStudyIs,
          "type": type,
          "department": "",
          "userlist": Object.values(this.userobject)
        };
        await axios
          .post(`${this.baseurl}/etmf/document/sharedocument`, savedata
            , {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
          .then((res) => {
            this.userListsss = res.data;
            alert("Document shared successfully");
            this.loadingSaveModalBtn = false
            this.closeShareFolderPermission('File');
          })
          .catch((err) => {
            console.log(err);
            this.loadingSaveModalBtn = false
          });
      }
    },
    /*Folder share functionalities end*/
    async updateFolderName() {
      this.retrieve = false;
      this.updateFolder.folderName = this.folderNames;
    },

    // async validateNameIsNull() {
    //   this.updateFolder.folderName = this.folderbyid.folderName.replace(/ +/g, ' ').trim();
    //   if (this.updateFolder.folderName == "") {
    //     this.editFolderErrors[0] = true;
    //     this.loadingEditFolder=false
    //   } else if (this.updateFolder.folderName.trim("") == "") {
    //     this.editFolderErrors[0] = true;
    //     this.loadingEditFolder=false
    //   } else {
    //     this.editFolderErrors[0]=false

    //   }
    // },

    async trim() {
      this.values.FolderName = this.values.FolderName.replace(
        /^\s+|\s+$/gm,
        ""
      );
    },
    async closebutton() {
      this.errors[1] = true;
      this.retrieve = true;
    },

    loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.getDocuments();
    },
  },
};
